// Should be kept in sync with:
// content4j/ContentModel/src/main/java/com/hubspot/content/model/ISO639Code.java
export const RTL_LANGUAGES = ['ar', 'ar-DZ', 'ar-BH', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SY', 'ar-TN', 'ar-AE', 'ar-YE', 'fa', 'he', 'ur'];